import { Button } from '@sunstone/ui';
import { ExternalLink, MessageCircle } from 'lucide-react';

const SUPPORT_SLACK_URL = 'https://uniphore.slack.com/archives/C0A9XC300UT';

export function StillStuckCallout() {
  return (
    <div className="flex flex-col items-start gap-3 rounded-lg border border-border bg-muted/30 p-6 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-center gap-3">
        <MessageCircle className="h-5 w-5 shrink-0 text-muted-foreground" />
        <div>
          <p className="font-medium text-foreground">Still stuck?</p>
          <p className="text-sm text-muted-foreground">
            Ask in the Sunstone Slack channel — someone can help.
          </p>
        </div>
      </div>
      <Button asChild variant="outline" size="sm" className="gap-2">
        <a href={SUPPORT_SLACK_URL} target="_blank" rel="noopener noreferrer">
          Ask in Slack
          <ExternalLink className="h-4 w-4" />
        </a>
      </Button>
    </div>
  );
}
